// @flow
import './default-bundle';

import LegacyComparisonGrid from '@components/containers/LegacyComparisonGrid';
import DesignYourOwnRing from '@components/dyor/Container';

ReactOnRails.register({
  DesignYourOwnRing,
  LegacyComparisonGrid
});
